<template>
    <section class="bg-light-gray section-padding" id="program-lojalnosti">
        <div class="mx-auto max-w-lg text-center pb-5 px-3">
            <h2 class="mb-3 text-center">Program lojalnosti</h2>
            <p>
                Jedna aplikacija. Dva načina za uštedu.<br />
                Ako želiš da skupljaš poene i potrošiš ih kasnije za umanjenje
                računa, izaberi program sa poenima.<br
                    class="d-none d-lg-block"
                />
                Ako želiš da pri kupovini odmah ostvariš uštedu, tu je dinarski
                popust.<br />
                Kad instaliraš aplikaciju, automatski ti je aktiviran Program
                lojalnosti sa poenima.
            </p>
        </div>
        <div
            class="d-flex flex-column flex-md-row align-items-center justify-content-center gap-4 pt-3"
        >
            <div
                class="max-w-xs d-flex flex-column align-items-center text-center gap-2 gap-sm-3 px-3 px-md-0"
            >
                <img
                    class="w-2.5rem"
                    src="/img/application/vector/points.svg"
                    alt="Poene"
                />
                <div>
                    <strong class="subtitle d-inline-block mb-2">
                        Program sa poenima
                    </strong>
                    <p>
                        Skupljaš poene pri svakoj kupovini, napreduješ kroz tri
                        nivoa u zavisnosti od potrošnje i koristiš poene za
                        umanjenje računa. Što viši nivo dostigneš, veće
                        pogodnosti uživaš.
                    </p>
                </div>
            </div>
            <div
                class="max-w-xs d-flex flex-column align-items-center text-center gap-2 gap-sm-3 px-3 px-md-0"
            >
                <img
                    class="w-2.5rem"
                    src="/img/application/vector/discount.svg"
                    alt="Popust"
                />
                <div>
                    <strong class="subtitle d-inline-block mb-2">
                        Program sa dinarskim popustom
                    </strong>
                    <p>
                        Ostvaruješ automatski popust pri svakoj kupovini prema
                        važećoj skali popusta, kao i u dosadašnjoj verziji
                        aplikacije. Iznos popusta je uvek isti i ne menja se u
                        zavisnosti od tvoje potrošnje.
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<style scoped>
.w-2\.5rem {
    width: 2.5rem;
}
</style>
